export default __webpack_public_path__ + "media/images/corporate/apartments/second_slide_sm-ce7cc95a6f91ece4710ff05100da5c03.png";